module.exports = __webpack_public_path__ + "img/task.e6caeb97.svg";